module.exports = __webpack_public_path__ + "img/bg40.f0b79469.png";